import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import { LoginRestrictedError } from '@pages/LoginRestricted/LoginRestricted';

const companyStatusCodes = [404];
const companyErrors = ['COMPANY NOT FOUND'];

const documentSigningErrors = [
  'QUALIFIED INVESTORS ONLY',
  'VERIFIED CUSTOMERS ONLY',
  'IDENTITY DOCUMENT NOT SYNCHRONIZED',
  'INVESTOR QUALIFICATION UPDATE NOT SYNCHRONIZED',
  'DOCUMENT SIGNING FAILED',
];
const documentSigningStatusCodes = [503, 433, 436, 400];

export const loginRestrictedErrorMsgs = [
  LoginRestrictedError.Terminated,
  LoginRestrictedError.Suspended,
];
export const loginRestrictedStatusCode = 403;

const defaultMsg = GlobalIntlSingleton.intl.formatMessage({
  id: 'misc.somethingWentWrong',
});

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      let message = action?.payload?.data?.detail ?? defaultMsg;

      if (action?.payload?.status === 'FETCH_ERROR') {
        return next(action);
      }
      if (
        action?.payload?.status === loginRestrictedStatusCode &&
        (message === 'USER NOT FOUND' || message === 'WRONG PASSWORD')
      ) {
        message = GlobalIntlSingleton.intl.formatMessage({
          id: 'login.errors.invalidCredentials',
        });
      }

      if (
        action?.payload?.status === loginRestrictedStatusCode &&
        loginRestrictedErrorMsgs.includes(action?.payload?.data?.msg)
      ) {
        return next(action);
      }

      if (action?.payload?.status === 401) {
        // message = GlobalIntlSingleton.intl.formatMessage({
        //   id: 'misc.sessionExpired',
        // });
        return next(action);
      }

      if (
        documentSigningStatusCodes.includes(action?.payload?.status) &&
        documentSigningErrors.includes(action?.payload?.data?.msg)
      ) {
        return next(action);
      }

      if (
        companyStatusCodes.includes(action?.payload?.status) &&
        companyErrors.includes(action?.payload?.data?.msg)
      ) {
        return next(action);
      }

      toast(message, {
        type: 'error',
      });
    }

    return next(action);
  };
